import { render, staticRenderFns } from "./EmailDetails.vue?vue&type=template&id=5619992a&scoped=true"
import script from "./EmailDetails.vue?vue&type=script&lang=js"
export * from "./EmailDetails.vue?vue&type=script&lang=js"
import style0 from "./EmailDetails.vue?vue&type=style&index=0&id=5619992a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5619992a",
  null
  
)

export default component.exports